import clsx from 'clsx';
import { useNotifications } from '../notifications.context';
import HubertPopover from 'components/HubertUI/HubertPopover';
import NotificationsIcon from 'components/Notifications/NotificationsIcon';
import NotificationsList from 'components/Notifications/NotificationsList';

const NotificationsPopover = () => {
  const { popOverisOpen, setPopOverIsOpen } = useNotifications();

  return (
    <HubertPopover open={popOverisOpen} onOpenChange={setPopOverIsOpen}>
      <HubertPopover.Trigger>
        <NotificationsIcon />
      </HubertPopover.Trigger>
      <HubertPopover.Content
        side="left"
        className={clsx(
          'min-w-[35vw]',
          'max-w-[35vw]',
          // 'min-h-[50vh]',
          'max-h-[90vh]',
          'h-full w-full',
          'p-4',
          'overflow-auto',
        )}
      >
        <NotificationsList />
      </HubertPopover.Content>
    </HubertPopover>
  );
};

export default NotificationsPopover;
